import { type IPrivateCompany } from '@inpart-io/padme-iap';
import { type MutationTree } from 'vuex';

import { type IPrivateCompanyState } from './types';

export const SET_MATCHES = 'SET_MATCHES';

export const mutations: MutationTree<IPrivateCompanyState> = {
    [SET_MATCHES](_state, { companyId, matches }: { companyId: number; matches: IPrivateCompany[] }) {
        _state.matches.set(companyId, matches);
    }
};
